const app_color_palette = [
  '#F57C73',
  '#1BC98E',
  '#5B4C91',
  '#C62CFF',
  '#69C5D4',
  '#FF46BD',
  '#992638',
  '#FFC91B',
];

export default app_color_palette;
